<template>
    <nav v-if="pages > 1" role="navigation" aria-label="Products Navigation" class="pagination mt-2">
        <ul class="nav justify-content-center">
            <li v-if="currentPage != 1">
                <button
                    @click="loadPrevPage"
                    :aria-label="prevPageText"
                    class="page-numbers"
                    >
                    <i class="fa fa-angle-left"></i>
                </button>
            </li>
            <li v-for="page in pageRange" :key="page">                
                <button
                    class="page-numbers"
                    :class="{current: isCurrentItem(page)}"
                    @click="loadProductPage(page)"
                    :aria-label="`${transitionPageText} ${page}`"
                    :aria-selected="isCurrentItem(page)"
                    :disabled="page == currentPage"
                >{{page}}</button>
            </li>
            <li v-if="currentPage != pages">
                <button
                    @click="loadNextPage"
                    :aria-label="nextPageText"
                    class="page-numbers"
                    >
                    <i class="fa fa-angle-right"></i>
                </button>
            </li>
        </ul>
    </nav>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'pagination',
    props: {
        nextPage: {
            type: String,
            default: 'Go to next page'
        },
        prevPage: {
            type: String,
            default: 'Go to previous page'
        },
        transitionPage: {
            type: String,
            default: "Go to page"
        },
        midSize: {
            type: Number,
            default: 3
        },
        maxSize: {
            type: Number,
            default: 7
        }
    },
    computed: {
      nextPageText() { return TG.vue.labels.navigation.nextPage || this.nextPage},
      prevPageText() { return TG.vue.labels.navigation.prevPage || this.prevPage},
      transitionPageText() { return TG.vue.labels.navigation.transitionPage || this.transitionPage},
        labels() {
          return TG.vue.labels.navigation || {
            nextPageText: this.nextPageText,
            prevPageText: this.prevPageText,
            transitionPageText: this.transitionPageText
          }
        },
        pages() {
            return this.getPages()
        },
        currentPage() {
            return this.getCurrentPage()
        },
        pageRange() {
            let range = [];
            let pages = this.getPages()
            let current = this.getCurrentPage()
            let startingPoint = current >= (this.midSize + 1) ? current - this.midSize: 1
            let endingPoint = startingPoint + this.maxSize
            if (endingPoint > pages) {
                endingPoint = pages + 1
            }
            
            for (let index = startingPoint; index < endingPoint; index++) {
                range.push(index)                
            }

            return range
        }
    },
    methods: {
        ...mapGetters([
            'getPages',
            'getCurrentPage'
        ]),
        ...mapActions([
            'loadProductPage'
        ]),
        loadNextPage() {
            this.loadProductPage(this.currentPage + 1)
        },
        loadPrevPage() {
            this.loadProductPage(this.currentPage - 1)
        },
        isCurrentItem(pageNum) {
            return pageNum === this.currentPage
        }
    }
}
</script>